import { render, staticRenderFns } from "./IconQuotes.vue?vue&type=template&id=7c28762a"
import script from "./IconQuotes.vue?vue&type=script&lang=js"
export * from "./IconQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports